<template>
    <Button class="!rounded-full" :as="link ? 'a' : (router && !disabled ? 'router-link' : 'button')" :icon="icon"
        :label="label" :href="link" :to="{ name: router }" :target="link ? '_blank' : ''" :loading="loading"
        :disabled="disabled" :type="type" @click.stop="emit('on-action', $event)" :severity="severity"
        :outlined="outlined"
        :pt="{ label: { class: isBold ? '!font-bold' : '' } }">
    </Button>
</template>

<script lang="ts" setup>

const emit = defineEmits(['on-action']);

const props = withDefaults(defineProps<{
    label: string,
    type?: 'button' | 'submit' | 'reset' | undefined;
    link?: string,
    router?: string,
    icon?: string,
    loading?: boolean,
    disabled?: boolean,
    severity?: string,
    outlined?: boolean,
    isBold?: boolean,
}>(), {
    label: '',
    type: 'button',
    link: '',
    router: '',
    icon: '',
    loading: false,
    disabled: false,
    severity: 'primary',
    outlined: false,
    isBold: false,
})
</script>